/*
  ============================================================
  carrinho.js — Helper de carrinho (add-to-cart via AJAX)
  ============================================================

  O QUE FAZ:
  Melhoria progressiva para adicionar produtos ao carrinho sem
  recarregar a pagina. Intercepta o envio de qualquer formulario
  de add-to-cart, envia para a Cart AJAX API do Shopify
  (/cart/add.js), atualiza o contador do carrinho no header
  (buscando /cart.js) e mostra uma confirmacao leve via
  window.mostrarAlerta (definido em snippets/alerta.liquid).

  OBSERVACOES:
  Funciona sem JS: o formulario de produto ja envia nativamente
  para /cart/add. Se a requisicao AJAX falhar, o script faz
  fallback e submete o formulario do jeito tradicional.
  O contador usa elementos com [data-cart-count]. O texto do
  alerta vem de window.themeStrings.addedToCart quando disponivel.
*/
(function () {
  'use strict';

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  // Monta o corpo do POST para /cart/add.js.
  //
  // No caso normal o proprio FormData do formulario basta. Mas quando a opcao
  // escolhida leva um brinde (atributo data-gift-variant no radio), o carrinho
  // precisa receber os DOIS itens: o Shopify nunca adiciona o produto Y de um
  // desconto "compre X, leve Y" — ele so zera o preco se o item ja estiver no
  // carrinho. Nesse caso vai um JSON com a lista de itens.
  function montarEnvio(form) {
    var escolha = form.querySelector('input[name="quantity"]:checked');
    var brinde = escolha && escolha.getAttribute('data-gift-variant');
    var principal = form.querySelector('[name="id"]');

    if (!brinde || !principal) {
      return { headers: { 'Accept': 'application/json' }, body: new FormData(form) };
    }

    return {
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: Number(principal.value), quantity: Number(escolha.value) || 1 },
          { id: Number(brinde), quantity: 1 }
        ]
      })
    };
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form.matches('form[action$="/cart/add"], form[data-type="add-to-cart-form"]')) return;

    // Compra direta: botao com name="checkout" leva o cliente ao checkout em
    // vez de deixa-lo na pagina com um toast.
    //
    // Importante: name="checkout" so tem efeito no formulario do CARRINHO
    // (action /cart). Num formulario de produto (/cart/add) o Shopify ignora e
    // manda para /cart. Por isso o redirecionamento e feito aqui: adiciona por
    // AJAX e so entao navega para o checkout.
    var submitter = event.submitter || form.querySelector('[name="checkout"]:focus');
    var compraDireta = !!(submitter && submitter.name === 'checkout');

    event.preventDefault();
    var button = submitter || form.querySelector('[type="submit"], [name="add"]');
    if (button) button.setAttribute('aria-busy', 'true');

    var envio = montarEnvio(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: envio.headers,
      body: envio.body
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (compraDireta) {
          // routes.root carrega o prefixo de idioma/mercado quando existe.
          var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          window.location.href = raiz.replace(/\/$/, '') + '/checkout';
          return;
        }
        refreshCartCount();
        if (typeof window.mostrarAlerta === 'function') {
          window.mostrarAlerta(
            (window.themeStrings && window.themeStrings.addedToCart) || 'Zum Warenkorb hinzugefügt',
            'positivo'
          );
        }
      })
      .catch(function () {
        // Fallback: submit the form the normal way.
        form.submit();
      })
      .finally(function () {
        if (button && !compraDireta) button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('submit', handleSubmit);
  document.addEventListener('DOMContentLoaded', refreshCartCount);
})();
